// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__vxwtu","addWidgetButton":"Header_addWidgetButton__241H2","dashboardTabs":"Header_dashboardTabs__3vCET","active":"Header_active__2rVT6"};